import { useEffect, useState } from "react";
import type { User } from "firebase/auth";
import { AdminDashboard } from "./components/AdminDashboard";
import { LoadingScreen } from "./components/LoadingScreen";
import { LoginScreen } from "./components/LoginScreen";
import { Storefront } from "./components/Storefront";
import { isAdminUser, observeAuth } from "./lib/firebase";

const previewRole = import.meta.env.DEV ? import.meta.env.VITE_PREVIEW_ROLE : undefined;

export default function App() {
  const [user, setUser] = useState<User | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => observeAuth((authenticatedUser) => {
    setUser(authenticatedUser);
    setIsLoading(false);
  }), []);

  if (previewRole === "admin") return <AdminDashboard />;
  if (previewRole === "customer") return <Storefront />;
  if (isLoading) return <LoadingScreen />;
  if (!user) return <LoginScreen />;
  return isAdminUser(user) ? <AdminDashboard /> : <Storefront />;
}
